const config = {
    // BASE_URL_API: 'https://zwpf3wivp7.execute-api.ap-northeast-1.amazonaws.com/dev-lae-api/',
    // dev
    // BASE_URL_API: 'https://d2kpjw082nkcyt.cloudfront.net/dev-iriomote-lae-api/',
    // BASE_URL_WEB: 'https://d2kpjw082nkcyt.cloudfront.net',
    // LINE_LINK: 'https://liff.line.me/2005902102-MQdyyE53',
    // LIFF_ID: '2005902102-MQdyyE53',
    // ADD_FRIEND_LINK: 'https://lin.ee/xbg6TmK',
    // prod
    BASE_URL_API: 'https://lae-iri.com/prod2-iriomote-lae-api/',
    BASE_URL_WEB: 'https://d3d7vcnq13gbp2.cloudfront.net',
    // BASE_URL_API: 'http://localhost:3000/',
    LINE_LINK: 'https://liff.line.me/2009547115-FCoqBild/',
    LIFF_ID: '2009547115-FCoqBild',
    ADD_FRIEND_LINK: 'https://line.me/R/ti/p/@204mqxaq',
    GOOGLE_MAP_API_KEY: 'AIzaSyB2eTL0AZnczp9q2C1sMYsF4DqSIifPT5Y',
    LINE_URL: 'https://line.me/R/',
};

const Environments = {
    baseUrl: config.BASE_URL_API,
    baseUrlWeb: config.BASE_URL_WEB,
    googleMapApiKey: config.GOOGLE_MAP_API_KEY,
    lineLink: config.LINE_LINK,
    lineUrl: config.LINE_URL,
    liffId: config.LIFF_ID,
    addFriendLink: config.ADD_FRIEND_LINK,
};

export default Environments;
